export const isMoreThan30DaysAgo = function (dateToCompare: string): boolean {
  const today = new Date()
  const thirtyDaysAgo = new Date(today)
  thirtyDaysAgo.setDate(today.getDate() - 30)
  const inputDate = new Date(Date.parse(dateToCompare))
  return inputDate < thirtyDaysAgo
}